import { useSelector } from "react-redux";
import { RootState } from "store";

// آیتم‌های سبد خرید
export const useCartItems = () =>
  useSelector((state: RootState) => Object.values(state.cart.items));

// تعداد کل آیتم‌ها
export const useCartTotalCount = () =>
  useSelector((state: RootState) =>
    Object.values(state.cart.items).reduce(
      (sum, item) => sum + item.quantity,
      0,
    ),
  );

// مجموع قیمت کل
export const useCartTotalPrice = () =>
  useSelector((state: RootState) =>
    Object.values(state.cart.items).reduce(
      (sum, item) => sum + item.quantity * item.product.price,
      0,
    ),
  );

// تعداد یک آیتم خاص
export const useCartItemCountById = (id: number) =>
  useSelector((state: RootState) => state.cart.items[id]?.quantity || 0);

// آرایه ای از id , quantity  ایتم ها
export const useCartItemsIdAndCount = () =>
  useSelector((state: RootState) =>
    Object.entries(state.cart.items).map(([id, item]) => ({
      storeProductId: item.storeProductId,
      quantity: item.quantity,
    })),
  );

export const useSelectPendingOrder = () =>
  useSelector((state: RootState) => state.cart.pendingOrder);
